import "./LegalPage.css";
import HeroTitle from "../../layouts/HeroTitle/HeroTitle";

function LegalPage() {
  return (
    <div className="legal-page">
      <HeroTitle title="MENTIONS LÉGALES" />

      <div className="legal-container">
        <div className="legal-content">
          <section className="legal-section">
            <div className="legal-info">
              <p>
                Conformément aux dispositions de la loi n° 2004-575 du 21 juin 2004 pour la confiance en l'économie numérique, 
                il est précisé aux utilisateurs du site Toursbouillon l'identité des différents intervenants dans le cadre de sa 
                réalisation et de son suivi.
              </p>
            </div>
          </section>

          <section className="legal-section">
            <h2>Édition du site</h2>
            <div className="section-decoration"></div>
            <div className="legal-info">
              <p>
                Le présent site, accessible à l'URL https://toursbouillon.fr/ (le « Site »), est édité par :
              </p>
              <p>
                <strong>LUMAIN</strong>, société au capital de 1000 euros, inscrite au R.C.S. de TOURS sous le numéro 
                RCS TOURS 930 387 386, dont le siège social est situé au 6 rue des fusillés 37000 TOURS, 
                représenté(e) par Romain SAUNIER dûment habilité(e)
              </p>
              <p>
                Le numéro individuel TVA de l'éditeur est : <strong>FR71930387386</strong>.
              </p>
            </div>
          </section>

          <section className="legal-section">
            <h2>Hébergement</h2>
            <div className="section-decoration"></div>
            <div className="legal-info">
              <p>
                Le Site est hébergé par la société <strong>OVH SAS</strong>, situé 2 rue Kellermann - BP 80157 - 59053 Roubaix Cedex 1, 
                (contact téléphonique ou email : 1007).
              </p>
            </div>
          </section>

          <section className="legal-section">
            <h2>Directeur de publication</h2>
            <div className="section-decoration"></div>
            <div className="legal-info">
              <p>
                Le Directeur de la publication du Site est <strong>Romain SAUNIER</strong>.
              </p>
            </div>
          </section>

          <section className="legal-section">
            <h2>Nous contacter</h2>
            <div className="section-decoration"></div>
            <div className="legal-info">
              <p><strong>Par téléphone :</strong> +33247205060</p>
              <p><strong>Par email :</strong> toursbouillon@gmail.com</p>
              <p><strong>Par courrier :</strong> 6 rue des fusillés 37000 TOURS</p>
            </div>
          </section>

          <section className="legal-section">
            <h2>Données personnelles</h2>
            <div className="section-decoration"></div>
            <div className="legal-info">
              <p>
                Le traitement de vos données à caractère personnel est régi par notre Charte du respect de la vie privée, 
                disponible depuis la section "Charte de Protection des Données Personnelles", conformément au Règlement 
                Général sur la Protection des Données 2016/679 du 27 avril 2016 («RGPD»).
              </p>
            </div>
          </section>

          <section className="legal-section">
            <div className="legal-info">
              <p style={{ fontStyle: 'italic', marginTop: '2rem' }}>
                Génération des mentions légales par Legalstart.
              </p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}

export default LegalPage; 